// extracted by mini-css-extract-plugin
export default {"container":"CourseCerificatePage_container__LQqVk"};